module.exports = __webpack_public_path__ + "images/icons_v2/child-lock-on-3d986f3c.svg";